export const apiFetch = (sessionToken: string): typeof fetch => {
  return async (input, init) => {
    const headers = new Headers(init?.headers);

    headers.set("X-Session-Token", sessionToken);

    if (
      init?.method === "POST" ||
      init?.method === "PUT" ||
      init?.method === "PATCH"
    ) {
      if (init?.body && !(init.body instanceof FormData)) {
        headers.set("Content-Type", "application/json");
      }
    }

    return await fetch(input, {
      ...init,
      headers,
    });
  };
};
